/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.courseselectionblock[_ngcontent-%COMP%], .notesblock[_ngcontent-%COMP%], .orientationblock[_ngcontent-%COMP%], .proxyblock[_ngcontent-%COMP%], .testhistorydiv[_ngcontent-%COMP%], .timelineblock[_ngcontent-%COMP%]{margin-top:20px;margin-bottom:20px}.testhistory[_ngcontent-%COMP%]{border:1px solid #000;margin-bottom:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/requests/requests.component.css.shim.ngstyle.js.pre-build-optimizer.js